// extracted by mini-css-extract-plugin
export default {"item":"backendItem_item__9LGpp","items":"backendItem_items__4yQWh","message":"backendItem_message__EhG5Q","results":"backendItem_results__RTZ4L"};